module.exports = __webpack_public_path__ + "img/dentalia.bfa30c9a.png";